import ArtyFont from "components/Signature/fonts/Arty.otf";
import CreattionFont from "components/Signature/fonts/Creattion.otf";
import HandstaFont from "components/Signature/fonts/Handsta.otf";
import HolligateFont from "components/Signature/fonts/Holligate.ttf";
import MrsSaintDelafieldFont from "components/Signature/fonts/MrsSaintDelafield.ttf";
import SouthamFont from "components/Signature/fonts/Southam.otf";
import { AvailableFonts } from "./fonts";

export const prettifySignature = (signature?: string) => {
  return signature ? signature
    .toLowerCase()
    .split(" ")
    .map(x => x.replace(/^(.)/, (str: string) => str.toUpperCase())
      .trim())
    .join(" ") : "";
};

export const signatureTimeStampFormatter = new Intl.DateTimeFormat("en-US", {
  dateStyle: "medium",
  timeStyle: "long",
  timeZone: "America/New_York",
  hour12: false,
});

export function getFontUrl(name = AvailableFonts.Handsta) {
  switch (name) {
    case AvailableFonts.Arty:
      return ArtyFont;
    case AvailableFonts.Creattion:
      return CreattionFont;
    case AvailableFonts.Handsta:
      return HandstaFont;
    case AvailableFonts.Holligate:
      return HolligateFont;
    case AvailableFonts.MrsSaintDelafield:
      return MrsSaintDelafieldFont;
    case AvailableFonts.Southam:
      return SouthamFont;
    default:
      return HandstaFont;
  }
}

export type SignatureFontSettings = {
  fontSize: number,
  yShift: number,
}

export type SignatureFont = SignatureFontSettings & {
  font: ArrayBuffer
}

export function getFontSettings(name = AvailableFonts.Handsta): SignatureFontSettings {
  switch (name) {
    case AvailableFonts.Arty:
      return {
        fontSize: 45,
        yShift: -11,
      };
    case AvailableFonts.Handsta:
      return {
        fontSize: 30,
        yShift: -6,
      };
    case AvailableFonts.Creattion:
    case AvailableFonts.Holligate:
    case AvailableFonts.MrsSaintDelafield:
      return {
        fontSize: 20,
        yShift: 2,
      };
    case AvailableFonts.Southam:
      return {
        fontSize: 30,
        yShift: -4,
      };
    default:
      return {
        fontSize: 10,
        yShift: 0,
      };
  }
}

export async function loadFont(name = AvailableFonts.Handsta): Promise<SignatureFont> {
  const response = await fetch(getFontUrl(name));
  return {
    font: await response.arrayBuffer(),
    ...await getFontSettings(name),
  };
}